import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SmsService {

  baserApiUrl:string=environment.baseApi
  constructor(public http:HttpClient) { }

  getSms(filter:any){
    return this.http.get(`${this.baserApiUrl}sms?${filter}`,)
  }

  sendSms(data:any){
    return this.http.post(`${this.baserApiUrl}sms`,data)
  }
}
